import { ApplicationConfig, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { provideMarkdown, MARKED_OPTIONS } from 'ngx-markdown';
import { MsalService, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MsalGuard, MsalBroadcastService, MsalGuardConfiguration } from '@azure/msal-angular';
import { IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthService } from './services/auth/auth.service';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { provideState, provideStore } from '@ngrx/store';
import { dataReducer, listReducer } from './lib/reducer';
import { provideEffects } from '@ngrx/effects';
import { loadListEffect } from './lib/effect';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MyPreset } from '../theme-preset';
export function loggerCallback(logLevel: LogLevel, message: string) {
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.sso.adClientId,
      authority: `https://login.microsoftonline.com/${environment.sso.adTenantId}`,
      redirectUri: '/',
      postLogoutRedirectUri: '/signin',
    },
    cache: {
      cacheLocation: 'localStorage',
    },
    system: {
      loggerOptions: {
        loggerCallback: () => { },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: 'none' as any,
    authRequest: {
      scopes: environment.msalLogInRequest,
    },
    loginFailedRoute: '/signin',
  };
}

export function appInit(msal: MsalService, auth: AuthService) {
  return async () => {
    await msal.instance.initialize();
    await auth.initialize();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      theme: {
        preset: MyPreset
      }
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideStore({
      lists: listReducer,
      data: dataReducer
    }),
    provideEffects({ loadListEffect }),
    provideRouter(routes),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    MsalService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      deps: [MsalService, AuthService],
      multi: true
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    MsalGuard,
    MsalBroadcastService,
    ConfirmationService,
    MessageService,
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: {
          gfm: true,
          breaks: true,
        },
      },
    }),
  ]
};
